import PropTypes from 'prop-types';
import React, { useRef } from "react";
import { useSnackbar } from "notistack";

import "../styles.css"
import api from "./../../../../../services/api.js"

export default function UploadPae(props) {
    // declarando componente da snackbar
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    // faz o upload do pdf
    async function handleSubmit(event) {
        event.preventDefault();
        snack.current("Iniciando o carregamento, aguarde.", { variant: 'info' })
        var thumbnail = event.target.files[0];
        const data = new FormData();
        data.append("thumbnail", thumbnail);
        api.post(`/usinas/upload/paeb/${props.values._id}`, data)
            .then((res) => {
                props.setValues({
                    ...props.values,
                    'paeb_pdf': res.data.message,
                });
                snack.current("Arquivo carregado com sucesso!", { variant: 'success' })
            })
            .catch((error) => {
                console.log(error);
                snack.current("Falha ao carregar arquivo!", { variant: 'error' })
            });
    }

    return (
        <>
            <div className="rowTitle">
                <div className="titles">PAEB </div>
                <div className="title"> Importe o documento PDF do PAEB referente a esta usina</div>
            </div>
            <div className="fundoArquivo">
                <div className="upload">
                    <form>
                        <label htmlFor="fileee"> </label>
                        <input
                            accept=".pdf"
                            id="fileee"
                            multiple
                            type="file"
                            onChange={(event) => handleSubmit(event)}
                        />
                    </form>
                </div>
                <div className="arquivo">
                    Arquivo carregado: {props.values.paeb_pdf}
                </div>
            </div>
        </>
    )
}

UploadPae.propTypes = {
    values: PropTypes.object,
    setValues: PropTypes.func,
};
